import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { BreadcrumbsContainer } from '../../../common/containers/BreadcrumbsContainer';
import { SeoHeadingContainer } from '../../../common/containers/SeoHeadingContainer';
import { SeoTabsLinksContainer } from '../../../common/containers/SeoTabsLinksContainer';
import { SortContainer } from '../../../common/containers/SortContainer';
import { ListingHeaderSkeleton } from '../../components/ListingHeaderSkeleton';
import { ModerateButtonContainer } from '../ModerateButtonContainer';

export interface IListingHeaderContainerProps {
  className?: string;
  isLoading?: boolean;
}

export const ListingHeaderContainer: React.FC<IListingHeaderContainerProps> = ({ className, isLoading }) => {
  if (isLoading) {
    return <ListingHeaderSkeleton className={className} />;
  }

  return (
    <div className={cn(styles['root'], className)}>
      <BreadcrumbsContainer className={styles['breadcrumbs']} />
      <SeoTabsLinksContainer className={styles['seo-tabs-links']} />
      <SeoHeadingContainer className={styles['heading']} />
      <div className={styles['controls']}>
        <SortContainer className={styles['sort']} />
        <ModerateButtonContainer />
      </div>
    </div>
  );
};

ListingHeaderContainer.displayName = 'ListingHeaderContainer';
